<template>
  <BaseDialogContainer
    title="Sign Out"
    :subtitle="subtitle"
    :dialogModel="dialog"
  >
    <template #activatorButton="{ on: buttonOn, attrs: buttonAttrs }">
      <HeaderActionButton
        :onPressed="onActionButtonPressed"
        :attrs="buttonAttrs"
        :listeners="buttonOn"
      >
        <template v-slot:icon>
          <v-icon>mdi-logout</v-icon>
        </template>
      </HeaderActionButton>
    </template>
    <template #icon>
      <v-icon color="primary">mdi-logout</v-icon>
    </template>
    <template #primaryButton>
      <v-btn
        rounded
        block
        color="primary"
        @click="onSignOutPressed"
        elevation="0"
      >
        Sign Out
      </v-btn>
    </template>
  </BaseDialogContainer>
</template>

<script>
import BaseDialogContainer from "@/core/BaseDialogContainer.vue";
import HeaderActionButton from "@/views/home/components/HeaderActionButton.vue";
export default {
  components: {
    BaseDialogContainer,
    HeaderActionButton,
  },
  data() {
    return {
      dialog: false,
      subtitle: "You'll need to sign in again to access your account",
    };
  },
  methods: {
    onActionButtonPressed() {
      this.dialog = true;
    },
    onSignOutPressed() {
      this.dialog = false;
      this.$msal.signOut();
      localStorage.removeItem("quad_token");
      sessionStorage.clear();
    },
  },
};
</script>

<style scoped>
</style>

